import { useToast as useChakraToast } from '@chakra-ui/react';

// Custom hook that wraps Chakra's useToast with default settings
export const useToast = () => {
  const toast = useChakraToast();

  const showToast = ({ title, description, status = 'info', duration = 5000 }) => {
    toast({
      title,
      description,
      status,
      duration,
      isClosable: true,
      position: 'top-right',
    });
  };

  const showSuccess = (title, description) => {
    showToast({ title, description, status: 'success' });
  };

  const showError = (title, description) => {
    showToast({ title, description, status: 'error', duration: 7000 });
  };

  const showWarning = (title, description) => {
    showToast({ title, description, status: 'warning' });
  };

  const showInfo = (title, description) => {
    showToast({ title, description, status: 'info' });
  };

  return {
    showToast,
    showSuccess,
    showError,
    showWarning,
    showInfo,
  };
};
